import { useAuth } from "../lib/auth";
import UserDashboard from "./UserDashboard";
import ProviderDashboard from "./ProviderDashboard";
import AdminDashboard from "./AdminDashboard";
import { Navigate } from "react-router-dom";

export default function DashboardRouter() {
  const { user } = useAuth();
  if (user === undefined) return <div className="pt-32 px-6 text-muted">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ redirect: "/dashboard" }}/>;
  if (user.role === "admin") return <AdminDashboard/>;
  if (user.role === "provider") return <ProviderDashboard/>;
  return <UserDashboard/>;
}
